import { render, staticRenderFns } from "./PropertyComp.vue?vue&type=template&id=7b7c45e9&"
import script from "./PropertyComp.vue?vue&type=script&lang=js&"
export * from "./PropertyComp.vue?vue&type=script&lang=js&"
import style0 from "./PropertyComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports